export default __webpack_public_path__ + "static/media/bg.949f0a58.jpg";